import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from './state';

const getLastRequestDateTime = (state: AppState): moment.Moment => state.lastRequestDateTime;

export const selectAppState = createFeatureSelector<AppState>('app');

export const selectLastRequestDateTime = createSelector(selectAppState, getLastRequestDateTime);
